import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from "./api/_util";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import $ from 'jquery';
window.$ = $;

Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.prototype.$api = api;
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
}).$mount('#app')
